import { DisplayableData } from 'entities-next/common'

// We cannot link it directly to Logic enum since it causes TypeScript to think
// that CheckLogic is not a string enum, causing failures in many places.
export enum CheckLogic {
  organizationHeadquarters = 'organization-headquarters',
  negativeOrganizationHeadquarters = 'negative-organization-headquarters',
  organizationStage = 'organization-stage',
  organizationFoundedAt = 'organization-founded-at',
}

export enum SignalLogic {
  foundersHaveStudiedAtTargetSchool = 'founders-have-studied-at-target-school',
  foundersHaveWorkedAtTargetCompany = 'founders-have-worked-at-target-company',
  foundersHaveExperienceInCompanyIndustries = 'founders-have-experience-in-company-industries',
  foundersHaveExperienceScalingCompanies = 'founders-have-experience-scaling-companies',
  headcountGrowth = 'headcount-growth',
  findFitInWebsite = 'find-fit-in-website',
  other = 'other',
}

export const SignalsWithFounder = [
  SignalLogic.foundersHaveStudiedAtTargetSchool as string,
  SignalLogic.foundersHaveWorkedAtTargetCompany as string,
  SignalLogic.foundersHaveExperienceInCompanyIndustries as string,
  SignalLogic.foundersHaveExperienceScalingCompanies as string,
]

export const SignalLogicTemplates = {
  'founders-have-studied-at-target-school': ['holds a * from ( * - * )'],
  'founders-have-worked-at-target-company': [
    'worked at * as * for * years  ( * - * )',
    'worked at * in various roles, including *, for a total of * years ( * - * )',
  ],
  'founders-have-experience-in-company-industries': ['has * years of experience in the * industry at *'],
  'founders-have-experience-scaling-companies': [
    'founded *, which went public in * at * $',
    'founded *, which was acquired in * by * for *',
    'founded *, which has raised * in * funding',
  ],
  'headcount-growth': [
    '1Y headcount growth: *%',
    '6m headcount growth: *%',
    'Headcount-to-last-round ratio: * employees/$M',
  ],
  'find-fit-in-website': [
    'Company’s fit with the Space was assessed based on content aggregated from multiple sources and not from the description (e.g. fit may be with a specific product/technology/patent they have). You can find the reference here*',
  ],
  other: [],
}

// We cannot link it directly to Logic enum since it causes TypeScript to think
// that InsightLogic is not a string enum, causing failures in many places.
export enum InsightLogic {
  organizationStage = 'organization-stage',
}

export type Check = {
  logic: CheckLogic
  data?: NumericCheckData | TextCheckData
}

export type NumericCheckData = {
  min?: number
  max?: number
}

export enum CheckDataLogic {
  or = 'or',
  and = 'and',
}

export type TextCheckData = {
  content: Array<{ value: string }>
  dataLogic: CheckDataLogic
}

export type SelectCheckDataContent<Entity = any> = DisplayableData & { value: Entity }
